import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import AuthHelper from './helpers/auth';

/* layouts */
import NavigationLayout from './layouts/navigation-layout';
import BlankLayout from './layouts/blank-layout';

/* containers */
import LoginPage from './containers/LoginPage';
import CallbackCasPage from './containers/CallbackCasPage';
import LogoutPage from './containers/LogoutPage';
import UnauthorizedPage from './containers/UnauthorizedPage';
import WebFormDetailPage from './containers/WebFormDetailPage';
import SubmitSuccessPage from './containers/SubmitSuccessPage';
import RatingPage from './containers/RatingPage';
import RatingSuccessPage from './containers/RatingSuccessPage';

const routes = [
	{ path: '/unauthorized', exact: true, isPrivate: false, Layout: BlankLayout, layoutClass: 'narrow', Component: UnauthorizedPage },
	{ path: '/login', exact: true, isPrivate: false, Layout: BlankLayout, layoutClass: 'narrow', Component: LoginPage },
	{ path: '/callback/cas', exact: true, isPrivate: false, Layout: BlankLayout, layoutClass: 'narrow', Component: CallbackCasPage },
	{ path: '/logout', exact: true, isPrivate: false, Layout: BlankLayout, layoutClass: 'narrow', Component: LogoutPage },
	{ path: '/web-form', exact: true, isPrivate: true, Layout: NavigationLayout, layoutClass: 'fill', Component: WebFormDetailPage },
	{ path: '/success', exact: true, isPrivate: true, Layout: NavigationLayout, layoutClass: 'fill', Component: SubmitSuccessPage },
	{ path: '/rating', exact: true, isPrivate: true, Layout: NavigationLayout, layoutClass: 'fill', Component: RatingPage },
	{ path: '/rating-success', exact: true, isPrivate: true, Layout: NavigationLayout, layoutClass: 'fill', Component: RatingSuccessPage }
];

function getRedirectedPath(location) {
	if (location.pathname.split('?')[0] === '/login' && location.pathname.split('?').length > 1) {
		return location.pathname + location.search + location.hash;
	}

	// skip the redirection from these routes
	if (['/login', '/callback/cas', '/logout'].indexOf(location.pathname.split('?')[0]) !== -1) {
		return '/login';
	}
	return `/login?path=${location.pathname + location.search + location.hash}`;
}

const PrivateRoute = ({ layout: Layout, layoutClass, component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (AuthHelper.isAuthenticated()) {
				return (
					<Layout containerClass={layoutClass}>
						<Component {...props} />
					</Layout>
				);
			} else {
				return (
					<Redirect to={getRedirectedPath(props.location)} />
				);
			}
		}}
	/>
);

export class Routes extends Component {
	render() {
		const { location } = this.props;
		return (
			<Switch location={location}>
				{routes.map(({ path, exact, isPrivate, Layout, layoutClass, Component }) => {
					if (isPrivate) {
						return <PrivateRoute
							key={0}
							path={path}
							exact={exact}
							layout={Layout}
							layoutClass={layoutClass}
							component={Component}
						       />;
					} else {
						return (
							<Route
								key={0}
								path={path}
								exact={exact}
								render={props => (
									<Layout
										containerClass={layoutClass}
										location={location}
									>
										<Component {...props} />
									</Layout>
								)}
							/>
						);
					}
				})}
				<Route render={props => AuthHelper.isAuthenticated() ? <Redirect to={'/web-form'} /> : <Redirect to={getRedirectedPath(props.location)} />} />
			</Switch>
		);
	}
}

export default withRouter(Routes);
